<template>
	<div 
		:style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center' }"
	>
		<v-container grid-list-lg>
      <v-card>
        <v-layout
            class="mb-3"
            align-center
            justify-center
            wrap  
          >
          <v-flex md4 order-sm2 class="mb-8" :style="{position:'relative',left:'5%'}">
            <strong>
              <span class="primary--text"><b>{{recordedWebinars.length}}</b></span>
              <span> Recorded added since</span>
            </strong>
            <span>as of {{recordedWebinars.length > 0 ? convertDate(recordedWebinars[0].created_at) : ""}}
            </span>
          </v-flex>
          <v-flex md4 order-sm2 class="mb-8" id="searchField" :style="{position:'relative',left:'5%'}">
            <v-text-field
              :style="{width:'90%'}"
              @input="handleChange"
              solo
              label="Search Webinar"
              prepend-icon="search"
              v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex md4 order-sm2 class="mb-8">
            <center>
              <v-select
                @change="handleFilter"
                :style="{width:'50%'}"
                :items="filterTypes"
                label="Category"
                v-model="categoryText"
              ></v-select>
            </center>
          </v-flex>
          
        </v-layout>
      </v-card>
      <v-card class="pa-4 mb-2">
		
			<v-layout wrap justify-center>
				<v-flex md10>
          <h1>View Recorded Webinars Below</h1>
          <br />
          <v-data-iterator
          content-tag="v-layout"
          row
          wrap
          :items="searchRecorded"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
        >
          <v-flex
            slot="item"
            slot-scope="webinar"
            xs12
            sm6
            md4
            lg4
          >
            <v-card
              hover
              @click.native="handleClick(webinar.item)"
            >
              <v-card-media
                :src="filesUrl + webinar.item.image"
                height="200"
                :style="{backgroundSize: 'contain'}"
              >
              </v-card-media>

              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-content>
                    <span :style="{fontSize: '70%'}">
                      <strong>{{ webinar.item.title }}</strong>
                    </span>
                    <span :style="{fontSize: '55%'}">
                      {{ webinar.item.description }}
                    </span>
                    <span :style="{fontSize: '50%'}"> <b class="accent--text">{{webinar.item.category}}</b> · {{convertDate(webinar.item.created_at)}}</span>
                    <span :style="{fontSize: '55%'}">
                      {{ webinar.item.code }}
                    </span>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>

              <v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-data-iterator>
				</v-flex>
			</v-layout>
      </v-card>
      <v-layout>
        <v-dialog
          v-model="dialog"
          max-width="500"
        >
          <v-card>
            <v-card-title class="headline">{{selectedWebinar.title}}</v-card-title>  
            <div>
              <Media 
                :style="{width: '500px'}"
                :kind="'video'"
                :controls="true"
                :src="[filesUrl + selectedWebinar.video]"
              >
              </Media>
            </div>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
		</v-container>
	</div>
</template>

<script>
import Media from '@dongido/vue-viaudio'
import axios from 'axios'
import config from '../../../configApi'
import moment from 'moment'

const apiUrl = config.apiUrl
const filesUrl = config.filesUrl

export default {
  data () {
    return {
      bg: require('@/assets/bg/water_6.png'),
      search: '',
      rowsPerPageItems: [3, 6, 12, 18],
      pagination: {
        rowsPerPage: 5
      },
      dialog: false,
      selectedWebinar: {},
      recordedWebinars: [],
      linkedWebinars: [],
      searchLinked: [],
      searchRecorded: [],
      filterTypes: ['All'],
      url: apiUrl.replace('api', ''),
      filesUrl,
      categoryText: ''
    }
  },
  components: {
    Media
  },
  mounted () {
    this.fetchData()
  },
  updated () {
    this.updateLog()
  },
  methods: {
    updateLog () {
    },
    handleFilter (selected) {
      if (selected === 'All') {
        selected = ''
      }
      let data = this.linkedWebinars.filter(val => val.category ? val.category.toLowerCase().includes(selected.toLowerCase()) : [])
      let recordedData = this.recordedWebinars.filter(val => val.category ? val.category.toLowerCase().includes(selected.toLowerCase()) : [])
      this.searchRecorded = recordedData
      this.searchLinked = data
      this.search = ''
    },
    handleChange () {
      let { search, recordedWebinars } = this
      let data = recordedWebinars.filter(val => val.title ? val.title.toLowerCase().includes(search.toLowerCase()) : [])
      this.searchLinked = data
      this.searchRecorded = data
      this.categoryText = ''
    },
    fetchData () {
      this.getWebinar()
    },
    convertDate (date) {
      return moment(date).format('LL')
    },
    getWebinar () {
      axios.get(`${apiUrl}/webinar`).then((res) => {
        this.recordedWebinars = res ? res.data.filter(val => val.is_recorded === 1) : []
        this.linkedWebinars = res ? res.data.filter(val => val.is_recorded === 0) : []
        this.searchLinked = this.linkedWebinars
        this.searchRecorded = this.recordedWebinars

        this.searchLinked.map(row => {
          if (!this.filterTypes.includes(row.category)) {
            this.filterTypes.push(row.category)
          }
        })
        this.searchRecorded.map(row => {
          if (!this.filterTypes.includes(row.category)) {
            this.filterTypes.push(row.category)
          }
        })
      }).catch(e => {
        console.log('error', e)
      })
    },
    handleClick (webinar) {
      this.dialog = true
      this.selectedWebinar = webinar
    }
  }
}
</script>
<style scoped>
    .position {
        font: 'initial'
    }
    a {
      text-decoration: none;
      color: black;
      font-weight: bold;
    }
    #searchField {
      position: relative;
      top: 1.5em;
    }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/webinar.vue